(function () {
  'use strict';

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function getNextWorkingDay(from) {
    var d = new Date(from);
    d.setDate(d.getDate() + 1);
    while (d.getDay() === 0 || d.getDay() === 6) {
      d.setDate(d.getDate() + 1);
    }
    return d.toLocaleDateString(undefined, { weekday: 'long' });
  }

  customElements.get('delivery-timer') || customElements.define('delivery-timer', class extends HTMLElement {
    connectedCallback() {
      this._cutoffHour = parseInt(this.dataset.cutoffHour, 10);
      this._cutoffMinute = parseInt(this.dataset.cutoffMinute, 10);
      this._nextDayMessage = this.dataset.nextDayMessage || 'Order by {day} for next-day dispatch';

      this._preEl = this.querySelector('[data-delivery-pre]');
      this._timeEl = this.querySelector('[data-delivery-time]');
      this._postEl = this.querySelector('[data-delivery-post]');
      this._msgEl = this.querySelector('[data-delivery-message]');

      if (!this._timeEl || !this._msgEl) return;

      this._update = () => this.update();
      this.update();
      this._interval = setInterval(this._update, 1000);
    }

    disconnectedCallback() {
      if (this._interval) {
        clearInterval(this._interval);
        this._interval = null;
      }
    }

    update() {
      var now = new Date();
      var day = now.getDay();
      var isWeekday = day >= 1 && day <= 5;

      var cutoff = new Date(now);
      cutoff.setHours(this._cutoffHour, this._cutoffMinute, 0, 0);

      if (isWeekday && now < cutoff) {
        var diff = cutoff - now;
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);

        this._timeEl.textContent = h > 0
          ? h + 'h ' + pad(m) + 'm ' + pad(s) + 's'
          : m + 'm ' + pad(s) + 's';

        if (this._preEl) this._preEl.hidden = false;
        this._timeEl.hidden = false;
        if (this._postEl) this._postEl.hidden = false;
        this._msgEl.hidden = true;
      } else {
        var nextDay = getNextWorkingDay(now);
        this._msgEl.textContent = this._nextDayMessage.replace('{day}', nextDay);

        if (this._preEl) this._preEl.hidden = true;
        this._timeEl.hidden = true;
        if (this._postEl) this._postEl.hidden = true;
        this._msgEl.hidden = false;
      }
    }
  });
})();
